module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    staticClass: "inventoryTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filteredAcceptableMaterials()
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.denomination'),
      "min-width": "15%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(parseFloat(scope.row.denomination.value).toFixed(2)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.material'),
      "min-width": "10%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.inventorypanel.' + scope.row.denomination.material)))])]
      }
    }])
  }), _vm._v(" "), (_vm.hasRecycler) ? _c('el-table-column', {
    attrs: {
      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.recycled'),
      "min-width": "10%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          staticClass: "item-checkbox"
        }, [_c('el-checkbox', {
          attrs: {
            "checked": scope.recycled,
            "disabled": !_vm.overridden || _vm.readOnly
          },
          on: {
            "change": function($event) {
              _vm.updateSettings()
            }
          },
          model: {
            value: (scope.row.recycled),
            callback: function($$v) {
              _vm.$set(scope.row, "recycled", $$v)
            },
            expression: "scope.row.recycled"
          }
        })], 1)]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.hasMinAmount) ? _c('el-table-column', {
    attrs: {
      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.min'),
      "min-width": "15%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          staticClass: "custom-label"
        }, [_c('el-input', {
          attrs: {
            "type": "number",
            "disabled": !_vm.overridden || _vm.readOnly
          },
          on: {
            "change": function($event) {
              _vm.updateSettings()
            }
          },
          model: {
            value: (scope.row.minAmount),
            callback: function($$v) {
              _vm.$set(scope.row, "minAmount", $$v)
            },
            expression: "scope.row.minAmount"
          }
        })], 1)]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.hasLowAmount) ? _c('el-table-column', {
    attrs: {
      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.low'),
      "min-width": "15%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          staticClass: "custom-label"
        }, [_c('el-input', {
          attrs: {
            "type": "number",
            "min": "0",
            "disabled": !_vm.overridden || _vm.readOnly
          },
          on: {
            "change": function($event) {
              _vm.updateSettings()
            }
          },
          model: {
            value: (scope.row.lowAmount),
            callback: function($$v) {
              _vm.$set(scope.row, "lowAmount", $$v)
            },
            expression: "scope.row.lowAmount"
          }
        })], 1)]
      }
    }])
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.optimum'),
      "min-width": "15%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          staticClass: "custom-label"
        }, [_c('el-input', {
          attrs: {
            "type": "number",
            "min": "0",
            "disabled": !_vm.overridden || _vm.readOnly
          },
          on: {
            "change": function($event) {
              _vm.updateSettings()
            }
          },
          model: {
            value: (scope.row.optimumAmount),
            callback: function($$v) {
              _vm.$set(scope.row, "optimumAmount", $$v)
            },
            expression: "scope.row.optimumAmount"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), (!_vm.hasLowAmount && _vm.hasMaxAmount) ? _c('el-table-column', {
    attrs: {
      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.max'),
      "min-width": "15%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          staticClass: "custom-label"
        }, [_c('el-input', {
          attrs: {
            "type": "number",
            "min": "0",
            "disabled": !_vm.overridden || _vm.readOnly
          },
          on: {
            "change": function($event) {
              _vm.updateSettings()
            }
          },
          model: {
            value: (scope.row.maxAmount),
            callback: function($$v) {
              _vm.$set(scope.row, "maxAmount", $$v)
            },
            expression: "scope.row.maxAmount"
          }
        })], 1)]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.hasHightAmount) ? _c('el-table-column', {
    attrs: {
      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.high'),
      "min-width": "15%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          staticClass: "custom-label"
        }, [_c('el-input', {
          attrs: {
            "type": "number",
            "min": "0",
            "disabled": !_vm.overridden || _vm.readOnly
          },
          on: {
            "change": function($event) {
              _vm.updateSettings()
            }
          },
          model: {
            value: (scope.row.highAmount),
            callback: function($$v) {
              _vm.$set(scope.row, "highAmount", $$v)
            },
            expression: "scope.row.highAmount"
          }
        })], 1)]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.valueColumn) ? _c('el-table-column', {
    attrs: {
      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.value'),
      "min-width": "15%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          staticClass: "custom-label"
        }, [_c('el-input', {
          attrs: {
            "type": "number",
            "min": "0",
            "disabled": !_vm.overridden || _vm.readOnly
          },
          on: {
            "change": function($event) {
              _vm.updateSettings()
            }
          },
          model: {
            value: (scope.row.value),
            callback: function($$v) {
              _vm.$set(scope.row, "value", $$v)
            },
            expression: "scope.row.value"
          }
        })], 1)]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.maxDispensableColumn) ? _c('el-table-column', {
    attrs: {
      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.maxDispensable'),
      "min-width": "15%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.denomination.material === 'COIN') ? _c('el-form-item', {
          staticClass: "custom-label"
        }, [_c('el-input', {
          class: {
            'max-dispensable-invalid': _vm.isInvalid(scope.row)
          },
          attrs: {
            "type": "number",
            "min": "0",
            "max": _vm.getMaxDispensable(scope.row.denomination.value, scope.row.denomination.material),
            "disabled": !_vm.overridden || _vm.readOnly
          },
          on: {
            "change": function($event) {
              _vm.updateSettings(scope.row, 'maxDispensable')
            }
          },
          model: {
            value: (scope.row.maxDispensable),
            callback: function($$v) {
              _vm.$set(scope.row, "maxDispensable", $$v)
            },
            expression: "scope.row.maxDispensable"
          }
        })], 1) : _vm._e()]
      }
    }])
  }) : _vm._e()], 1), _vm._v(" "), (_vm.nonRecyleableMaterials().length) ? _c('div', {
    staticStyle: {
      "width": "400px"
    }
  }, [_c('h4', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.inventorypanel.nonRecyclable')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "data": _vm.nonRecyleableMaterials()
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.denomination'),
      "min-width": "15%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(parseFloat(scope.row.denomination.value).toFixed(2)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('management.unit.softwaresettings.inventorypanel.material'),
      "min-width": "10%",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.$t('management.unit.softwaresettings.inventorypanel.' + scope.row.denomination.material)))])]
      }
    }])
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ef8e4406!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dq-ui/packages/inventorypanel/src/inventorypanel.vue
// module id = 524
// module chunks = 36